export enum ActionType {
    CREATE,
    DELETE,
    UPDATE,
    CANCEL, // Todo : Remove this
    FILTER,
    SELECT,
    REQUEST_UPDATE,
    NEW,
}